import { render, staticRenderFns } from "./create-data-view-modal.vue?vue&type=template&id=73ac60ab&scoped=true"
import script from "./create-data-view-modal.vue?vue&type=script&lang=js"
export * from "./create-data-view-modal.vue?vue&type=script&lang=js"
import style0 from "./create-data-view-modal.vue?vue&type=style&index=0&id=73ac60ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ac60ab",
  null
  
)

export default component.exports